import React from 'react';

import Thumb from '../img/works/wasek-portfolio-single-page.jpg';
import Service from '../img/work-details/wasek-portfolio-single-page-service.jpg';
import Portfolio from '../img/work-details/wasek-portfolio-single-page-portfolio.jpg';

const WasekPortfolioSinglePage = {
    id: 6, permalink: "wasek-portfolio-single-page", thumb: Thumb, title: "Wasek Portfolio Single Page", category: "Web Template", categoryURL: "webtemplate", detailImg1: Service, detailImg2: Portfolio, previewTxt: "Preview", previewURL: "https://wasek-portfolio-single-page.web.app/", sourceTxt: "", sourceURL: "", description: <>
        <h3 className="mbSmall">Wasek Portfolio Single Page is a Single Page Portfolio HTML Template.</h3>
        <p>&nbsp;</p>

        <h5>Main Feature:</h5>
        <ul>
            <li>Design With HTML5, CSS3 &amp; JavaScript</li>
            <li>Google Web Font Include</li>
            <li>Fully Responsive Web Template</li>
            <li>Smooth Scrolling Menu Bookmark</li>
            <li>Back To Top Smooth Scrolling</li>
            <li>Portfolio With Responsive Filter</li>
            <li>Footer Social Share Icons</li>
        </ul>
    </>
};

export default WasekPortfolioSinglePage;